import React, { FC } from "react";
import { Tabs as AntdTabs } from "antd";
import IndexChart from "./IndexChart";
import Volatitlity from "./Volatility";
import PeriodPL from "./PeriodPL";
import WinnersLosers from "./WinnersLosers";
import HeatMap from "./HeatMap";
import { ICryptoIndex } from "../../models/cryptoindex.model";

const { TabPane } = AntdTabs;

interface IProps {
  index: ICryptoIndex;
}

const Tabs: FC<IProps> = ({ index }) => {
  return (
    <AntdTabs defaultActiveKey="1">
      <TabPane tab="Index chart" key="1">
        <IndexChart index={index} />
      </TabPane>
      <TabPane tab="Volatility" key="2">
        <Volatitlity />
      </TabPane>
      <TabPane tab="Period P&L" key="3">
        <PeriodPL />
      </TabPane>
      <TabPane tab="Winners/Losers" key="4">
        <WinnersLosers />
      </TabPane>
      <TabPane tab="Heat Map" key="5">
        <HeatMap />
      </TabPane>
    </AntdTabs>
  );
};

export default Tabs;
